import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import {Helmet} from 'react-helmet';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import Input from '../../components/UI/Input/Input';
import Spinner from '../../components/UI/Spinner/Spinner';
import classes from './Auth.css';
import * as actions from '../../store/actions/index';

import { useMobile } from '../../store/utility';

class Auth extends Component {
    constructor(props){
        super(props);
        this.loginControl = {
            email: {
                colWidth: 12,
                elementType: 'input',
                elementConfig: {
                    type: 'email',
                    placeholder: 'Email Address'
                },
                value: '',
                validation: {
                    required: true,
                    isEmail: true
                },
                valid: false,
                touched: false
            },
            password: {
                colWidth: 12,
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: 'Password'
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 6
                },
                valid: false,
                touched: false
            }
        };
        this.signupControl = {
            email: {
                colWidth: 12,
                elementType: 'input',
                elementConfig: {
                    type: 'email',
                    placeholder: 'Email Address'
                },
                value: '',
                validation: {
                    required: true,
                    isEmail: true
                },
                valid: false,
                touched: false
            },
            first_name: {
                colWidth: 6,
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'First Name'
                },
                value: '',
                validation: {
                    required: true,
                    isEmail: false
                },
                valid: false,
                touched: false
            },
            last_name: {
                colWidth: 6,
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'Last Name'
                },
                value: '',
                validation: {
                    required: true,
                    isEmail: false
                },
                valid: false,
                touched: false
            },
            password: {
                colWidth: 12,
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: 'Password'
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 6
                },
                valid: false,
                touched: false
            },
            password_confirm: {
                colWidth: 12,
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: 'Confirm Password'
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 6
                },
                valid: false,
                touched: false
            }
        };

        // default the auth page to sign up, unless the url specifically pointing to login
        if (this.props.match.params.action === "login") {
            this.state = {
                controls: this.loginControl,
                isSignup: false
            }
        }
        else {
            this.state = {
                controls: this.signupControl,
                isSignup: true,
            };
        }
    }


    checkValidity ( value, rules ) {
        let isValid = true;
        if ( !rules ) {
            return true;
        }

        if ( rules.required ) {
            isValid = value.trim() !== '' && isValid;
        }

        if ( rules.minLength ) {
            isValid = value.length >= rules.minLength && isValid
        }

        if ( rules.maxLength ) {
            isValid = value.length <= rules.maxLength && isValid
        }

        if ( rules.isEmail ) {
            const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
            isValid = pattern.test( value ) && isValid
        }

        if ( rules.isNumeric ) {
            const pattern = /^\d+$/;
            isValid = pattern.test( value ) && isValid
        }

        return isValid;
    }

    inputChangedHandler = ( event, controlName ) => {
        const updatedControls = {
            ...this.state.controls,
            [controlName]: {
                ...this.state.controls[controlName],
                value: event.target.value,
                valid: this.checkValidity( event.target.value, this.state.controls[controlName].validation ),
                touched: true
            }
        };
        this.setState( { controls: updatedControls } );
    }

    submitHandler = ( event ) => {
        event.preventDefault();
        if (this.state.isSignup){
            this.props.onSignup( this.state.controls.email.value, this.state.controls.password.value, this.state.isSignup,
                this.state.controls.password_confirm.value, 
                this.state.controls.first_name.value, this.state.controls.last_name.value );
        }
        else {
            this.props.onAuth( this.state.controls.email.value, this.state.controls.password.value, this.state.isSignup);
        }
    }

    switchAuthModeHandler = () => {
        this.setState(prevState => {
            if (prevState.isSignup){
                return {
                    controls: this.loginControl,
                    isSignup: !prevState.isSignup,
                };
            }
            else{
                return {
                    controls: this.signupControl,
                    isSignup: !prevState.isSignup,
                };
            }
        });
    }

    render () {

        let displaySize;
        if (useMobile()===true) {
            displaySize = 'none';
        }
        else {
            displaySize = 'none';
        }

        const formElementsArray = [];
        for ( let key in this.state.controls ) {
            formElementsArray.push( {
                id: key,
                config: this.state.controls[key]
            } );
        }

        let form = formElementsArray.map( formElement => (
            <Col md={formElement.config.colWidth} key={formElement.id}>
                <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                touched={formElement.config.touched}
                changed={( event ) => this.inputChangedHandler( event, formElement.id )} />
            </Col>
        ) );

        if (this.props.loading) {
            form = <Spinner />
        }

        let errorMessage = null;

        if (this.props.error) {
            errorMessage = (
                <p>{this.props.error.message}</p>
            );
        }

        let authRedirect = null;
        if (this.props.isAuthenticated) {
            authRedirect = <Redirect to={this.props.authRedirectPath}/>
        }

        let forgetPasswordButton = null;
        if (this.state.isSignup === false) {
            forgetPasswordButton = (
                <Row>
                    <Col block="true">
                        <div className={classes.forgetPassword}>
                        <a href='/assist/request_password_reset/'>forget password</a>
                        </div>
                    </Col>
                </Row>
            )
        }

        return (
            <div className={classes.Auth}>
                <Helmet>
                <title>Login / Sign Up | BookMeeY</title>
                <meta name="description" content="Sign up / login for BookMeeY. Join the BookMeeY movement and makes the world more connected." />
                </Helmet>
                {authRedirect}
                {errorMessage}
                <form onSubmit={this.submitHandler}>
                    <Row>
                        {form}
                    </Row>
                    <Row>
                        <Col>
                        <div className={classes.ConfirmButton}>
                        <Button variant="info" size={displaySize} type="submit">{this.state.isSignup ? 'Sign Up' : 'Login'}</Button>
                        </div>
                        </Col>
                    </Row>
                </form>
                <Row>
                    <Col>
                        <div className={classes.SwitchButton}>
                        <Button
                            size={displaySize}
                            onMouseDown={this.switchAuthModeHandler}
                            variant="outline-info">{this.state.isSignup ? 'I already have an account' : 'I want to sign up'}
                        </Button>
                        </div>
                    </Col>
                </Row>
                { forgetPasswordButton }
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        loading: state.auth.loading,
        error: state.auth.error,
        isAuthenticated: state.auth.token !== null,
        authRedirectPath: state.auth.authRedirectPath
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSignup: ( email, password, isSignup, password_confirm, first_name, last_name ) => dispatch( actions.auth( email, password, isSignup, password_confirm, first_name, last_name ) ),
        onAuth: ( email, password, isSignup ) => dispatch( actions.auth( email, password, isSignup ) ),
        onSetAuthRedirectPath: () => dispatch(actions.setAuthRedirectPath('/'))
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( Auth );


// WEBPACK FOOTER //
// ./src/containers/Auth/Auth.js